export default __webpack_public_path__ + "static/media/sykes.e777d757.jpg";